/**
 * 查询键常量
 */
export const QUERY_KEYS = {
  MEMBER_TYPE_LIST: 'member-type-list',
  MEMBER_TYPE_DETAIL: 'member-type-detail',
  PRIVILEGE_LIST: 'privilege-list',
} as const;

/**
 * 抽屉配置
 */
export const DRAWER_CONFIG = {
  WIDTH: 800,
  PLACEMENT: 'right' as const,
} as const;

/**
 * 表单默认值
 */
export const FORM_DEFAULT_VALUES = {
  status: 1, // 默认启用
  privilegeIds: [], // 默认空数组
  limitStatus: 0, // 默认否（不期间限定）
  recommendStatus: 0, // 默认否（不推荐）
} as const;

